import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <GoogleOAuthProvider clientId="1089699571363-5jdakk7gc65h0o9fj8jef189v4tnavaa.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);
